import React, { useState, useEffect, useRef, useMemo } from 'react';
import { Box, ButtonBase, Dialog, IconButton, makeStyles, Typography } from '@material-ui/core';
import _ from 'lodash';
import { bedStatusAPI, systemAPI } from '../../../../../apis';
import { AutoCompleteSelect, ColumnItem } from '../../../../../components';
import { CloseIcon, CompletedIcon, OutstandingIcon } from '../../../../../components/Icon';
import { i18n } from '../../../../../language';
import { bsMlookupListFunc } from '../../../bsEnumeration';
import BedStatusIcon from '../../BedStatusIcon';
import BookingTable from '../../BookingTable';
import Updatetoavailable from '../Updatetoavailable';
import bsApp, { bedP as P, remarkType } from '../../../bsApp';
import { alertMsg, ResponseCommCodeEnum } from '../../../../../apis/commlogic';
import { classNames, initValue } from '../../../../../utils';
import { OrderedCleaningService } from '../../ServiceOrder';
import ServiceOrderBtn from '../../ServiceOrder/ServiceOrderBtn';
import handleGetBsCleansingType from '../../../../../utils/handleGetBsCleansingType';
import { revampTableList } from '../../../../../utils/newBedStatusUtil';
import LinkedBedPopup from './LinkedBedPopup';

const useStyles = makeStyles((theme) => ({
  dialog: {
    '& .MuiPaper-root': {
      width: '100%',
      height: '100%',
      display: 'flex',
      justifyContent: 'center',
      background: 'transparent',
      boxShadow: 'unset',
    },
  },
  root: {
    minWidth: '60rem',
    display: 'flex',
    height: '49.375rem',
    borderRadius: '0.937rem',
    boxShadow: '0 -2px 21px 0 rgba(30, 56, 140, 0.18)',
    backgroundColor: '#fff',
    overflow: 'auto',
  },
  left: {
    display: 'flex',
    flexDirection: 'column',
    flexGrow: 1,
    // padding: '2.438rem 1.563rem 0 1.563rem',
    padding: '2.438rem 0 0 0',
    overflow: 'auto',
    minWidth: '30rem',
    flex: '1 1 60%',
  },
  right: {
    display: 'flex',
    flexDirection: 'column',
    padding: '0 1.563rem 0 1.5rem',
    borderLeft: 'solid 1px #ddd',
    minWidth: '15rem',
    maxWidth: '40rem',
    flex: '1 1 40%',
    overflow: 'auto',
  },
  bedBoBox: {
    display: 'flex',
    flexDirection: 'column',
    borderRadius: '0.937rem',
    backgroundColor: '#f5faff',
    padding: '1.536rem',
  },
  closeIcon: {
    display: 'flex',
    justifyContent: 'flex-end',
    marginBottom: '0.5rem',
    '&:hover': {
      cursor: 'pointer',
    },
  },
  iconButton: {
    color: '#538fff',
    fontSize: '1.375rem',
    marginRight: '-10px',
  },
  BedNumberBox: {
    width: '4.563rem',
    height: '4.563rem',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    borderRadius: '1.062rem',
    boxShadow: '0 -2px 21px 0 rgba(30, 56, 140, 0.07)',
    backgroundColor: '#fff',
  },
  updateToAvailable: {
    width: '11.375rem',
    height: '3rem',
    backgroundColor: '#4c93ff',
    borderRadius: '0.625rem',
    fontFamily: 'NotoSans-Medium',
    fontSize: '1rem',
    fontWeight: '500',
    color: '#fff',
  },
  saveRemark: {
    width: '11.375rem',
    height: '3rem',
    backgroundColor: '#f5faff',
    borderRadius: '0.625rem',
    fontFamily: 'NotoSans-Medium',
    fontSize: '1rem',
    fontWeight: '500',
    color: '#538fff',
    border: 'solid 1.5px #538fff',
  },
  bedStatus: {
    fontFamily: 'NotoSans-Bold',
    fontSize: '1.5rem',
    fontWeight: 'bold',
    lineHeight: '1.25',
    color: '#2e4469',
  },
  OCBox: {
    display: 'flex',
    padding: '1.688rem 0 1.375rem 0',
    borderRadius: '0.937rem',
    border: 'solid 1.2px #e4e7eb',
  },
  flexCenter: {
    flexBasis: '50%',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
  },
  BookingTable: {
    overflow: 'auto',
  },
  columnTitle: {
    fontFamily: 'NotoSans-Medium',
    fontSize: '1rem',
    fontWeight: '500',
    lineHeight: '1.5',
    color: '#525e6c',
  },
  columnItem: {
    flex: '1 1',
    display: 'flex',
    justifyContent: 'center',
  },
  columnBox: {
    display: 'flex',
    flexWrap: 'wrap',
    justifyContent: 'center',
    borderRadius: '0.937rem',
    border: '1.2px solid rgb(228, 231, 235)',
  },
  line: {
    width: '1px',
    background: '#e4e7eb',
    margin: '1rem 0',
  },
  label: {
    fontFamily: 'NotoSans-Medium',
    fontSize: '0.875rem',
    fontWeight: '500',
    color: '#7d86a9',
  },
  remarks: {
    fontFamily: 'NotoSans-Bold',
    fontSize: '1.25rem',
    fontWeight: 'bold',
    color: '#2e4469',
  },
  linked: {
    color: '#538fff',
    marginLeft: '0.5rem',
  },
  inputText: {
    '& *': {
      padding: '0',
      margin: '0',
      border: '0',
    },
    fontFamily: 'NotoSans-Medium',
    flex: '0 0',
    height: '3.5rem',
    lineHeight: '3.5rem',
    display: 'flex',
    justifyContent: 'center',
    alignContent: 'center',
    borderRadius: '0.625rem',
    border: 'solid 1px #e4e7eb',
    backgroundColor: '#fff',
    paddingLeft: '1.25rem',
    color: '#2e4469',
    fontSize: '1rem',
    '& .MuiInputBase-root': {
      fontFamily: 'NotoSans-Medium',
      color: '#2e4469',
    },
    '& :focus': {
      backgroundColor: 'unset',
    },
    '& :before': {
      content: 'none',
    },
    ':before': {
      content: 'none !important',
    },
    '& :after': {
      content: 'none',
    },
  },
  select: {
    '& .MuiSelect-iconOutlined': {
      color: '#538fff',
    },
  },
  btnGrops: {
    display: 'grid',
    marginBottom: '1rem',
    gap: '1.25rem',
    gridTemplateColumns: '1fr 1fr',
  },
}));

const requestHttp = async ({ setBsMlookupList, setBsRemarkList, setBsDiagnosisList, setHospitalWardList }) => {
  try {
    const getBsMlookupList = await bedStatusAPI.getBsMlookupList();
    setBsMlookupList(getBsMlookupList.result);

    const getBsRemarkList = await bedStatusAPI.getBsRemarkList();
    setBsRemarkList(getBsRemarkList.result.data);

    const getBsDiagnosisList = await bedStatusAPI.getBsDiagnosisList();
    setBsDiagnosisList(getBsDiagnosisList.result.data);

    const getSysHospitalWardList = await systemAPI.getSysHospitalWardList();
    setHospitalWardList(getSysHospitalWardList.result);
  } catch (error) {
    console.log(`---------${error}------------`);
  }
};

const onChangeCheckbox =
  ({ setCheckData, BsBookingList, setBsBookingList, setIsEadmList }) =>
  (data) =>
  () => {
    console.log('data', data);
    if (data.admissionType === 'EADM' && data.checkBedStatusId === false) {
      setIsEadmList(true);
      setCheckData(data);
      const list = _.map(BsBookingList, (item, index) => {
        return {
          ...item,
          changeIdStatus: item.changeIdStatus ? false : item.transferRequestId === data.id,
        };
      });
      setBsBookingList(list);
    } else {
      setIsEadmList(false);
      setCheckData(data);
      const list = _.map(BsBookingList, (item, index) => {
        return {
          ...item,
          changeIdStatus: item.changeIdStatus ? false : item.transferRequestId === data.id,
        };
      });
      setBsBookingList(list);
    }
  };

const initOldTransferId = (transferRequestId, setOldTransferId) => {
  setOldTransferId((o) => {
    if (!o.init) {
      return {
        init: true,
        value: transferRequestId,
      };
    } else {
      return o;
    }
  });
};

const handleBookingListEffect = ({ BsBookingList, setInputValues, InputValues, checkData, setOldTransferId }) => {
  _.map(BsBookingList, (item, index) => {
    if (item.changeIdStatus) {
      if (item.status === 'O') {
        setInputValues({
          ...InputValues,
          [P.forClinicalAdmission]: item.admissionType,
          transferRequestId: item.transferRequestId,
        });
        initOldTransferId(item.transferRequestId, setOldTransferId);
      } else {
        setInputValues({
          ...InputValues,
          [P.forClinicalAdmission]: '',
          action: 1,
          transferRequestId: null,
        });
      }
    }
    if (item.transferRequestId === checkData.id) {
      if (item.changeIdStatus) {
        setInputValues({
          ...InputValues,
          [P.forClinicalAdmission]: item.admissionType,
          action: 0,
          transferRequestId: item.transferRequestId,
        });
        initOldTransferId(item.transferRequestId, setOldTransferId);
      } else {
        setInputValues({
          ...InputValues,
          [P.forClinicalAdmission]: '',
          action: 1,
          transferRequestId: null,
        });
      }
    }

    initOldTransferId(null, setOldTransferId);
  });
};

const nextPageCall =
  ({
    count,
    BsBookingList,
    setBsMlookupList,
    setBsRemarkList,
    setBsDiagnosisList,
    setHospitalWardList,
    getBsBookingList,
  }) =>
  async (pageSize, pageNo) => {
    try {
      const shouldRequestHttp = count === null || count !== BsBookingList.length;
      if (shouldRequestHttp) {
        if (count === null) {
          await requestHttp({ setBsMlookupList, setBsRemarkList, setBsDiagnosisList, setHospitalWardList });
        }
        await getBsBookingList(pageSize, pageNo);
      }
    } catch (error) {
      console.log('-----Ward error-----', error);
    }
  };

const saveRemark =
  ({ InputValues, allData, setPopup, saveBedStatus, closePop, oldTransferId }) =>
  ({ bedStatusId = 0 }) => {
    if (
      InputValues.transferRequestId &&
      allData.linkeds &&
      bedStatusId === 0 &&
      oldTransferId.value !== InputValues.transferRequestId
    ) {
      setPopup(true);
    } else {
      saveBedStatus(
        {
          ...allData,
          ...InputValues,
          remarkType: remarkType.tbcAvailable,
          linkedBedStatusId: bedStatusId,
          action: bedStatusId === 0 ? InputValues.action : 0,
        },
        closePop
      ).catch();
    }
  };

export default function TbcAvailable({ allData, closePop, open, updateBedStatus, saveBedStatus }) {
  const classes = useStyles();
  const iconBgColors = ['#5cd9f4', '#44d7b6'];
  const [isUpdatetoavailablePop, setIsUpdatetoavailablePop] = useState(false);
  const closeUpdatetoavailablePop = () => {
    setIsUpdatetoavailablePop(false);
  };
  const showUpdatetoavailablePop = () => {
    setIsUpdatetoavailablePop(true);
  };
  const tableRef = useRef(null);
  const PAGESIZE = 20;
  const [count, setCount] = useState(null);
  const [popup, setPopup] = useState(false);
  const [oldTransferId, setOldTransferId] = useState({ value: null, init: false });

  const columnTitle = [i18n.t('BEDSTATUS_OUTSTANDING'), i18n.t('BEDSTATUS_COMPLETED_SINCE_HOURS_AGO')];

  const [BsBookingList, setBsBookingList] = useState([]);
  const [HospitalWardList, setHospitalWardList] = useState(null);
  const [BsDiagnosisList, setBsDiagnosisList] = useState(null);
  const [BsRemarkList, setBsRemarkList] = useState(null);
  const [BsMlookupList, setBsMlookupList] = useState(null);
  const [isEadmList, setIsEadmList] = useState(false);
  const EadmList = bsMlookupListFunc
    .getTypeLookupAddBlankFormat(BsMlookupList, 'bs_clinical_admission')
    .concat({ text: 'EADM', value: 'EADM' });
  const [columnData, setColumnData] = useState([
    { id: 3, IconCom: OutstandingIcon, text: 0 },
    { id: 4, IconCom: CompletedIcon, text: 0 },
  ]);

  const [IsEditPop, setIsEditPop] = useState(false);
  const editPopChange = (value) => {
    setIsEditPop(value);
  };

  const [InputValues, setInputValues] = useState({
    [P.bedCleaning]: initValue(allData?.[P.bedCleaning]),
    [P.forClinicalAdmission]: initValue(allData?.[P.forClinicalAdmission]),
    action: null,
    [P.ccWardCd]: initValue(allData?.[P.ccWardCd]),
  });
  useEffect(() => {
    setInputValues({
      [P.bedCleaning]: initValue(allData?.[P.bedCleaning]),
      [P.forClinicalAdmission]: initValue(allData?.[P.forClinicalAdmission]),
    });
  }, [allData]);

  const changeHandle = (type, key) => {
    return (event) => {
      type === 'select' && setInputValues({ ...InputValues, [key]: event });
    };
  };

  const confirmHanlder = () => {
    updateBedStatus(
      {
        ...allData,
        ...InputValues,
        targetStatus: bsApp.AVAILABLE,
        sourceStatus: bsApp.TBC,
        ccWardCd: allData?.[P.ccWardCd],
      },
      closePop
    ).catch();
  };

  const getBsBookingList = async (pageSize, pageNo) => {
    try {
      const { result } = await bedStatusAPI.getBsTransferRequestTbcList({
        pageNo: pageNo,
        pageSize: pageSize,
        bedStatusId: allData?.bedStatusId,
        // startDate: moment(moment().subtract(1, 'days').format('yyyy-MM-DD 00:00:00')).valueOf(),
        // endDate: moment(moment().add(1, 'days').format('yyyy-MM-DD 23:59:59')).valueOf(),
      });
      setCount(result?.count);
      setColumnData([
        { ...columnData[0], text: initValue(result?.outstandingCount, 0) },
        { ...columnData[1], text: initValue(result?.completedCount, 0) },
      ]);
      const decryptedData = await revampTableList(result.data);
      const newBsBookingList = [...BsBookingList.slice(0, (pageNo - 1) * pageSize), ...decryptedData];
      newBsBookingList.forEach((element) => {
        element.changeIdStatus = _.some(
          [allData?.bedStatusId, ..._.map(allData.linkeds, (item) => item.bedStatusId)],
          (item) => element?.checkBedStatusId === item
        );
      });
      setBsBookingList(newBsBookingList);
      return decryptedData;
    } catch (e) {
      console.log('-------------', e);
    }
  };

  const [checkData, setCheckData] = useState('');

  useEffect(() => {
    handleBookingListEffect({ BsBookingList, setInputValues, InputValues, checkData, setOldTransferId });
  }, [BsBookingList]);
  const [hideIndex, setHideIndex] = useState(null);
  const editSaveHandle = async (requestVal, editIndex) => {
    try {
      await bedStatusAPI.postUpdateBsBooking(requestVal);
      const pageNo = Math.ceil((editIndex + 1) / PAGESIZE);
      const temp = await getBsBookingList(PAGESIZE, pageNo);
      const index = temp?.findIndex((item) => item.transferRequestId === requestVal.transferRequestId);
      setHideIndex(index > -1 ? (pageNo - 1) * PAGESIZE + index : index);
      return true;
    } catch (error) {
      if (error.statusCode === ResponseCommCodeEnum.BED_VERSION) {
        alertMsg(
          i18n.t(
            'BEDSTATUS_THE_TRANSFER_IN_DETAIL_WAS_CHANGED_BY_OTHER_WARDPLACE_USER_PLEAS_REFRESH_WEB_PAGE_TO_GET_THE_LATEST_TRANSFER_IN_INFO_AND_CHECK_IF_FURTHER_ACTION_IS_REQUIRED'
          ),
          _.uniqueId('warning_'),
          'warning'
        );
      } else {
        console.log(`---------${error}------------`);
      }
    }
  };

  const linkedBeds = useMemo(() => {
    if (allData.linkeds) {
      return [
        `${allData.ccWardCd} ${allData.bedNo}`,
        ..._.map(allData.linkeds, (item) => `${item.ccWardCd} ${item.bedNo}`),
      ];
    } else {
      return [];
    }
  }, [allData]);

  return isUpdatetoavailablePop ? (
    <Updatetoavailable
      allData={allData}
      open={isUpdatetoavailablePop}
      closePop={closeUpdatetoavailablePop}
      confirmHanlder={confirmHanlder}
    />
  ) : (
    <Dialog open={open} maxWidth={false} className={classes.dialog} style={{ display: IsEditPop ? 'none' : 'block' }}>
      <div className={classes.root}>
        <div className={classes.left}>
          <div style={{ padding: '0 1.563rem' }}>
            <div className={classes.columnBox}>
              {columnData.map((item, index) => {
                return (
                  <React.Fragment key={item.id}>
                    {index === 1 && <div className={classes.line} />}
                    <div className={classes.columnItem}>
                      <ColumnItem
                        {...item}
                        title={columnTitle[index]}
                        iconBgColor={iconBgColors[index]}
                        style={{ width: 'unset', margin: '0' }}
                      />
                    </div>
                  </React.Fragment>
                );
              })}
            </div>
          </div>
          <BookingTable
            className={classes.BookingTable}
            allData={BsBookingList}
            hospitalWardList={HospitalWardList}
            BsDiagnosisList={BsDiagnosisList}
            BsRemarkList={BsRemarkList}
            editPopChange={editPopChange}
            bsMlookupList={BsMlookupList}
            ref={tableRef}
            nextPageCall={nextPageCall({
              count,
              BsBookingList,
              setBsMlookupList,
              setBsRemarkList,
              setBsDiagnosisList,
              setHospitalWardList,
              getBsBookingList,
            })}
            pageSize={PAGESIZE}
            showCheckbox={true}
            onChangeCheckbox={onChangeCheckbox({ setCheckData, BsBookingList, setBsBookingList, setIsEadmList })}
            seeIcon={true}
            saveHandle={editSaveHandle}
            hideIndex={hideIndex}
            currentBed={allData}
            tablePadding={true}
            remarkMinWidth="5rem"
            checkBoxPadding="0.813rem 0rem"
          />
        </div>
        <div className={classes.right}>
          <div className={classes.closeIcon}>
            <IconButton className={classes.iconButton} onClick={closePop}>
              <CloseIcon />
            </IconButton>
          </div>
          <div className={classes.btnGrops}>
            <ButtonBase
              id="bed_tbc_save_remark"
              className={classes.saveRemark}
              onClick={saveRemark({ InputValues, allData, setPopup, saveBedStatus, closePop, oldTransferId })}
            >
              {i18n.t('BEDSTATUS_SAVE_REMARK')}
            </ButtonBase>
            <ButtonBase
              id="bed_tbc_update_to_available"
              className={classes.updateToAvailable}
              onClick={showUpdatetoavailablePop}
            >
              {i18n.t('BEDSTATUS_UPDATE_TO_AVAILABLE')}
            </ButtonBase>
          </div>
          <div className={classes.bedBoBox}>
            <Box display="flex" alignItems="center" justifyContent="space-between">
              <Typography className={classes.remarks}>{i18n.t('BEDSTATUS_REMARKS')}</Typography>
              <div className={classes.BedNumberBox}>
                <BedStatusIcon allData={allData} disabled={true} />
              </div>
            </Box>
            <Box display="grid" gridTemplateColumns="1fr 1fr" gridGap="0.625rem" mt="0.625rem">
              <Box>
                <Typography className={classes.label} style={{ marginBottom: '0.625rem' }}>
                  {i18n.t('BEDSTATUS_BED_CLEANING')}
                </Typography>
                <AutoCompleteSelect
                  id="bed_tbc_bed_cleaning"
                  itemList={bsMlookupListFunc.getTypeLookupAddBlankFormat(BsMlookupList, 'bs_cleaning')}
                  value={InputValues?.[P.bedCleaning] ?? ''}
                  onChange={changeHandle('select', P.bedCleaning)}
                  placeholder={i18n.t('BEDSTATUS_SELECT_FROM_BELOW_ITEM')}
                />
              </Box>
              <Box>
                <Typography className={classes.label} style={{ marginBottom: '0.625rem' }}>
                  {i18n.t('BEDSTATUS_FOR_CLINICAL_ADMISSION')}
                </Typography>
                <AutoCompleteSelect
                  id="bed_tbc_for_clinical_admission"
                  itemList={
                    isEadmList
                      ? EadmList
                      : bsMlookupListFunc.getTypeLookupAddBlankFormat(BsMlookupList, 'bs_clinical_admission')
                  }
                  value={InputValues?.[P.forClinicalAdmission] ?? ''}
                  onChange={changeHandle('select', P.forClinicalAdmission)}
                  placeholder={i18n.t('BEDSTATUS_SELECT_FROM_BELOW_ITEM')}
                />
              </Box>
            </Box>
          </div>
          {allData.linkeds && (
            <Box display="flex" alignItems="center" mt="1rem">
              <div className={classes.label}>
                Linked Bed:<span className={classNames(classes.remarks, classes.linked)}>{linkedBeds.join(', ')}</span>
              </div>
            </Box>
          )}
          <Box mt="1rem">
            <ServiceOrderBtn
              hospCode={allData?.ccHosp}
              wardLocation={allData?.ccWardLocation}
              version={allData?.version}
              status={allData?.status}
              tableId={allData?.bedStatusId}
              tableName="B"
              closePop={closePop}
              reminder={`bed ${allData.linkedBedNo ?? allData?.bedNo}`}
              allData={allData}
              defaultLocation={`${allData.ccWardLocation} ${allData.ccWardCd ?? allData?.wardCd}`}
              defaultCleaningCase={handleGetBsCleansingType(allData)}
              defaultRemark={`${allData?.ccWardCd ?? allData?.wardCd} 床 ${allData?.bedNo}`}
            />
          </Box>
          <Box mt="1rem">
            <OrderedCleaningService
              marginLeft="0"
              tableName="B"
              tableId={allData?.bedStatusId}
              bedNo={allData?.bedNo}
              reminder={`bed ${allData?.bedNo}`}
            />
          </Box>
        </div>
      </div>
      {popup && (
        <LinkedBedPopup
          allData={allData}
          handleClose={() => setPopup(false)}
          handleSubmit={saveRemark({ InputValues, allData, setPopup, saveBedStatus, closePop, oldTransferId })}
        />
      )}
    </Dialog>
  );
}
